import { ConfirmationDialogService } from 'src/app/services/confirmation-dialog.service';
import {
  Component,
  ElementRef,
  forwardRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  inject
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Store } from '@ngrx/store';
import { debounce, difference, isEqual } from 'lodash-es';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { AppGlobalService } from 'src/app/services/app.global.service';

@Component({
  selector: 'vb-consumerapps-select',
  templateUrl: './consumerapps-select.component.html',
  styleUrls: ['./consumerapps-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ConsumerappsSelectComponent),
      multi: true
    }
  ],
  standalone: false  //NOSONAR
})
export class ConsumerappsSelectComponent implements OnInit, OnChanges, OnDestroy {
  private confirmationDialogService = inject(ConfirmationDialogService);
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);
  private messageService = inject(MessageService);
  private store = inject(Store);
  private appGlobalService = inject(AppGlobalService);

  @Input() element: any;
  @Input() fieldIdMap: any;
  @Input() formData: any;
  @Input() consumerList: any;
  @Input() disableField = false;
  @ViewChild('mSelect') mSelect;
  private modelValue: any;
  private onChange: (m: any) => void;
  private onTouched: (m: any) => void;
  subscriptions: Subscription[] = [];
  allFields: any[] = [];
  source: any[] = [];
  target: any[] = [];
  showPickList = false;
  selected: any[];
  targetBackup: any[];
  fromSave = false;
  lists: any;
  appId: any;

  ngOnChanges() {
    this.setOptions();
  }

  ngOnInit(): void {
    this.setOptions();
  }

  setOptions() {
    this.allFields = this.consumerList;
    console.log(this.allFields);
    if (this.formData.consumers) {
      this.writeValue(this.formData.consumers);
    }
  }

  get model() {
    return this.modelValue;
  }

  writeValue(value: any): void {
    this.setValueToPickList(value);
    this.modelValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  set(value: any) {
    this.modelValue = value;
    this.onChange(this.modelValue);
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
    // this.disabled = isDisabled;
  }

  togglePickList(event?: any) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      this.target = [...this.selected];
      this.source = difference(this.allFields, this.target);
      this.targetBackup = [...this.target];
    }
    this.showPickList = !this.showPickList;
  }

  setValueToPickList(value) {
    this.selected = [];
    this.target = [];
    if (value) {
      if (value.length > 0) {
        value.forEach((ele) => {
          const e = this.allFields.filter((x) => x.sid === ele.appId);
          this.target.push(e[0]);
        });
        this.source = difference(this.allFields, this.target);
      } else {
        this.source = [...this.allFields];
        this.target = [];
      }
    } else {
      this.source = [...this.allFields];
      this.target = [];
    }
    if (!this.target) {
      this.target = [];
    }
    this.selected = [...this.target];
  }

  onMoveToTarget(event) {
    console.log(event);
  }

  onMoveToSource(event) {
    console.log(event);
  }

  onTargetReorder(event) {
    console.log(event);
  }

  setValueToForm(list) {
    const newArray = list.map((a) => ({ appId: a.sid, contextPath: a.contextPath }));
    //let value = list.map(a => a.sid).join();
    this.modelValue = newArray;
    this.onChange(this.modelValue);
  }

  savePicklist() {
    this.selected = [...this.target];
    this.setValueToForm(this.target);
    this.fromSave = true;
    this.togglePickList();
  }
  showMessage(status: string, message: string, detail?: string) {
    this.messageService.clear();
    const sticky = status === 'error';

    this.messageService.add({
      life: 10000,
      severity: status,
      summary: message,
      detail: detail,
      sticky: sticky
    });
  }

  debounceValChanges = debounce(this.setValueToForm.bind(this), 1000);

  updateValues(event) {
    if (this.element.lookupTo === 'listoffieldsExpImgFA' && event.value.length > 16) {
      this.mSelect.value = [];
      this.showMessage('error', 'Maximum number of fields indexed is 16');
      event.stopPropagation();
      return;
    }
    // this.setValueToForm(this.selected);
    this.debounceValChanges(this.selected);
  }

  closeDialog(event) {
    if (!isEqual(this.target, this.targetBackup) && !this.fromSave) {
      this.confirmationDialogService.confirm({
        message: 'You have unsaved changes. Are you sure you want to leave this page?',
        accept: () => {
          this.showPickList = false;
          this.target = [...this.targetBackup];
        },
        reject: () => {
          this.showPickList = true;
        }
      });
    } else {
      this.showPickList = false;
    }
    this.fromSave = false;
  }

  ngOnDestroy(): void {
    //AutoUnsubscribe
    $(this.elementRef.nativeElement).remove();
  }
}



